export default function ConsentNotice() {
  return (
    <div className="rounded-lg border border-gray-200 bg-gray-50 p-4 dark:border-gray-700 dark:bg-gray-800 md:p-5">
      <h3 className="text-base font-bold text-gray-900 dark:text-gray-100">
        Recording Notice &amp; Consent
      </h3>
      <p className="mt-2 text-sm leading-5 text-gray-700 dark:text-gray-300">
        We record and transcribe our calls for quality assurance, training, and
        project preparation.
      </p>
      {/* Bullets hang outside the text column so a wrapped line lines up with
          the line above it instead of sliding back under the marker. */}
      <ul className="mt-3 list-outside list-disc space-y-2 pl-5 text-sm leading-5 text-gray-700 marker:text-gray-400 dark:text-gray-300 dark:marker:text-gray-500">
        <li>
          By clicking the blue &ldquo;Join &amp; Consent&rdquo; button, you
          agree to this recording.
        </li>
        <li>
          Your phone&rsquo;s location during the walkthrough is also recorded
          to map the walk to the video.
        </li>
        <li>If you do not consent, please do not join the call.</li>
      </ul>
    </div>
  );
}
